<section class="centered-with-padding flex flex-col gap-y-5 pt-10 desk:pt-5">
  @if (data.title; as title) {
    <app-title [title]="title" size="h1" />
  }
  <app-search
    (onOptionSelected)="onOptionSelected($event)"
    [debounceDelayMs]="300"
    [dropdownEnabled]="true"
    [placeholder]="'COMPONENT.STORE-LOCATOR.PLACEHOLDER_CITY_OR_POSTAL_CODE' | translate"
    [queryParamKey]="searchLocationParams"
    [searchSuggestions]="locationsOptions()"
    class="max-w-[286px]" />
  <div class="rounded-3xl bg-gray-light p-5">
    <app-map />
  </div>
  <div #storeList class="grid scroll-mt-[100px] grid-cols-1 gap-2.5 desk:grid-cols-3">
    @if (isStoreCardListVisible()) {
      @for (store of storesListDisplayed(); track index; let index = $index) {
        @if (store.uuid) {
          <div class="flex w-full flex-col justify-center gap-y-5 rounded-3xl bg-gray-light px-6 py-5">
            @if (store.brandAndStore; as brandAndStore) {
              <div class="flex flex-col items-center gap-y-1.5 font-title text-[20px]">
                <span>{{ brandAndStore[0] }}</span>
                <span>{{ brandAndStore[1] }}</span>
              </div>
            }
            <div class="flex justify-between">
              <div class="flex items-center gap-x-2">
                @if (store.distance !== null) {
                  <app-svg [inline]="true" [width]="26" src="assets/icons/pin.svg" />
                  {{ "COMPONENT.STORE-LOCATOR.DISTANCE_IN_KM" | translate: { km: store.distance } }}
                }
              </div>
              <div class="flex items-center gap-x-2">
                @if (store.isVisioAppointmentAvailable) {
                  <app-svg [inline]="true" [width]="26" src="assets/icons/camera.svg" />
                  {{ "COMPONENT.STORE-LOCATOR.VIDEO_APPOINTMENT_AVAILABLE" | translate }}
                }
              </div>
            </div>
            <div class="flex flex-col items-center gap-y-2 pb-3">
              @let hasAppointmentCta = data.hasAppointmentCta;
              @if (store.url) {
                @if (hasAppointmentCta) {
                  <app-button
                    (click)="emitGtmEvent(gtmEvent())"
                    [label]="'COMPONENT.STORE-LOCATOR.SELECT_THIS_STORE' | translate"
                    [url]="store.url" />
                } @else {
                  <app-button
                    (onButtonClick)="emitGtmEvent(gtmEvent()); onStoreAppointmentClick(store)"
                    [label]="'COMPONENT.STORE-LOCATOR.SELECT_THIS_STORE' | translate" />
                }
              }
              @if (hasAppointmentCta) {
                <app-button
                  (onButtonClick)="onStoreAppointmentClick(store)"
                  [label]="'COMPONENT.STORE-LOCATOR.BOOK_APPOINTMENT' | translate"
                  theme="WHITE" />
              }
            </div>
          </div>
        }
      }
    }
  </div>
</section>
